import { createSelector } from '@ngrx/store';
import { AccountTypes, FilteredAccount } from '@shared/models';
import {
  selectEligibleGiftingAccounts,
  selectEligibleGiftingAccountsMO,
  selectEligibleJointAccounts,
} from '@store/selectors/client-accounts/client-accounts.selectors';
import { selectMOGiftingToggle } from '@store/selectors/feature/feature.selectors';
import { selectAccountType } from '@store/selectors/triage/triage.selectors';

export const selectGiftingEligibility = createSelector(
  selectMOGiftingToggle,
  selectAccountType,
  selectEligibleJointAccounts(),
  selectEligibleGiftingAccounts(AccountTypes.INDV),
  selectEligibleGiftingAccounts(AccountTypes.TRUST),
  selectEligibleGiftingAccountsMO(AccountTypes.INDV),
  selectEligibleGiftingAccountsMO(AccountTypes.TRUST),
  (
    moGiftingToggle,
    accountType,
    eligibleJointAccounts,
    eligibleIndvAccounts,
    eligibleTrustAccounts,
    eligibleIndvAccountsMO,
    eligibleTrustAccountsMO,
  ) => {
    const accountFromType: AccountTypes = accountType ?? AccountTypes.EMPTY;

    const isJointAccountType =
      accountFromType === AccountTypes.JOINT || accountFromType === AccountTypes.JOINT_TENANTS_WROS;

    const indvAccounts = moGiftingToggle
      ? eligibleIndvAccountsMO.accounts
      : eligibleIndvAccounts.accounts;
    const trustAccounts = moGiftingToggle
      ? eligibleTrustAccountsMO.accounts
      : eligibleTrustAccounts.accounts;

    const isGiftingEligible: boolean =
      (accountFromType === AccountTypes.INDV && indvAccounts.length >= 1) ||
      (isJointAccountType && eligibleJointAccounts.accounts.length >= 1) ||
      (accountFromType === AccountTypes.TRUST && trustAccounts.length >= 1);

    let filterAccounts: FilteredAccount[] = [];

    if (isGiftingEligible) {
      switch (accountFromType) {
        case AccountTypes.INDV:
          filterAccounts = indvAccounts;
          break;
        case AccountTypes.JOINT:
        case AccountTypes.JOINT_TENANTS_WROS:
          filterAccounts = eligibleJointAccounts.accounts;
          break;
        case AccountTypes.TRUST:
          filterAccounts = trustAccounts;
          break;
      }
    }

    return {
      isGiftingEligible,
      accountFromType,
      filterAccounts,
    };
  },
);
